import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed, onBeforeMount, onBeforeUnmount, ref, onMounted,
} from 'vue';
import { useStore } from 'vuex';
import FooterSub from '@/components/footer/FooterSub.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseFooter',
  setup(__props) {

const store = useStore();
const root = ref<InstanceType<typeof HTMLElement>>();
const pageType = computed(() => store.getters['page/pageType']);

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'footer');
  store.dispatch('menus/fetchBySlug', 'footer-sub');
});

const menuSub = computed(() => store.getters['menus/menu']('footer-sub'));

const checkFooterPosition = () => {
  if (root.value) {
    root.value.style.removeProperty('padding-top');

    if (pageType.value !== 'order') {
      const position = root.value?.getBoundingClientRect();
      const footerOffset = window.innerHeight - position.bottom;

      if (footerOffset > 0) {
        root.value.style.setProperty('padding-top', `${footerOffset}px`);
      }
    }
  }
};

onMounted(() => {
  window.addEventListener('load', checkFooterPosition);
  window.addEventListener('fetched', checkFooterPosition);
  window.addEventListener('resize', checkFooterPosition);
  checkFooterPosition();
});

onBeforeUnmount(() => {
  window.removeEventListener('load', checkFooterPosition);
  window.removeEventListener('fetched', checkFooterPosition);
  window.removeEventListener('resize', checkFooterPosition);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    ref_key: "root",
    ref: root,
    class: "d-print-none"
  }, [
    _createVNode(FooterSub, {
      items: menuSub.value || []
    }, null, 8, ["items"])
  ], 512))
}
}

})